import { render } from "./TextAreaInput.vue?vue&type=template&id=ad4bfbd8&scoped=true"
import script from "./TextAreaInput.vue?vue&type=script&lang=js"
export * from "./TextAreaInput.vue?vue&type=script&lang=js"

import "./TextAreaInput.vue?vue&type=style&index=0&id=ad4bfbd8&lang=scss&scoped=true"

import exportComponent from "/var/www/recruitment-form-front-end-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad4bfbd8"]])

export default __exports__